import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATE_TRACKERS_PERMISSIONS } from '@modules/affiliate-trackers/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IAffiliateTrackersConditionResponse,
} from '../types';
import {
  AFFILIATE_TRACKERS_CONDITION_GET_QUERY_KEY,
  AFFILIATE_TRACKERS_CONDITION_GET_URL,
} from '../constants';

export default function useAffiliateTrackersConditionQuery(
  id: Ref<number>,
): IContextQueryResult<IAffiliateTrackersConditionResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliateTrackersConditionResponse>({
    queryKey: [AFFILIATE_TRACKERS_CONDITION_GET_QUERY_KEY, id],
    queryFn: ({ signal }) => fetchGet<IAffiliateTrackersConditionResponse>(
      AFFILIATE_TRACKERS_CONDITION_GET_URL,
      {
        signal,
        permission: AFFILIATE_TRACKERS_PERMISSIONS.SHOW,
        urlParams: {
          id: id.value,
        },
      },
    ),
    enabled: computed(() => !!id.value),
  });
}
